import { render, staticRenderFns } from "./detailclass.vue?vue&type=template&id=7089253d&scoped=true"
import script from "./detailclass.vue?vue&type=script&lang=js"
export * from "./detailclass.vue?vue&type=script&lang=js"
import style0 from "./detailclass.vue?vue&type=style&index=0&id=7089253d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7089253d",
  null
  
)

export default component.exports